import {
    useState,
    useEffect,
    useCallback,
} from 'react';
import { useRecoilState } from 'recoil';

import { addressesState } from 'store/state';
import { webLibSdk } from 'helpers';
import toastAlert from 'components/UI/Alert';

import claimDataCalc from './allocationClaimDataCalc';

const useAllocationClaimData = (auth) => {
    const [isLoading, setLoading] = useState(true);
    const [claimInfo, setClaimInfo] = useState({});
    const [addresses] = useRecoilState(addressesState);

    const getData = useCallback(async () => {
        try {
            let allocation = await webLibSdk.allocation(addresses.current);
            let calcedData = {};
            let types = [];
            let vesting = 0;
            let lockupPeriod = 0;

            if (!allocation || ['NotAllocated', 'Canceled'].includes(allocation?.state)) {
                allocation = await webLibSdk.customAllocation(addresses.current);
                calcedData = claimDataCalc({ ...allocation, allocationType: 'Custom Allocation' }, auth);
                calcedData.isCustom = true;
            } else {
                types = await webLibSdk.allocationTypes();
                const currentType = types.filter((x) => x.type === allocation.allocationType)[0];
                vesting = currentType.vesting;
                lockupPeriod = currentType.lockupPeriod;
                calcedData = claimDataCalc({ ...allocation, vesting, lockupPeriod }, auth);
            }

            setClaimInfo(calcedData);
        } catch (err) {
            console.error('Error getting allocation claim data:', err);
            toastAlert({
                type: 'error',
                customMessage: err,
            });
        } finally {
            setLoading(false);
        }
    }, [addresses, auth]);

    useEffect(() => {
        if (!addresses.current) return;

        getData();
    }, [addresses, getData]);

    return {
        data: claimInfo,
        isLoading,
        refetch: getData,
        mutation: setClaimInfo,
    };
};

export default useAllocationClaimData;
